import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BorrowerApi } from '@sg/api/borrower-api';
import { SgEntityBasedSession } from '../../misc';

@Component({
  selector: 'sg-borrower-entity-input',
  templateUrl: './entity-input.component.html',
  styleUrls: ['./entity-input.component.scss'],
  host: {
    style: 'display: flex; width: 100%;',
  },
  standalone: false,
})
export class SgBorrowerEntityInputComponent {
  @Input() withFormControl: FormControl;
  @Input() revertTooltipMsg: string;
  @Input() errorValidatorsMessages: { string: string };
  @Input() session: SgEntityBasedSession;
  @Input() availability: BorrowerApi.AvailabilitySplitDto[];

  @Output() selectionChange: EventEmitter<BorrowerApi.AvailabilitySplitDto> = new EventEmitter();
  @Output() onBlurRow = new EventEmitter<void>();

  constructor() {}
}
